import {AfterViewInit, Component, ElementRef, OnInit, Renderer2} from '@angular/core';

import {PasswordResetInitService} from './password-reset-init.service';
import {MixpanelService} from "@logbook/core/tracking/mixpanel.service";
import {MixpanelEvent} from "@logbook/core/tracking/mixpanel-event.enum";
import {first} from "rxjs/operators";

@Component({
    selector: 'dln-password-reset-init',
    templateUrl: './password-reset-init.component.html',
    styleUrls: [
        'password-reset-init.scss'
    ]
})
export class PasswordResetInitComponent implements OnInit, AfterViewInit {
    error: string;
    resetAccount: any;
    success: string;
    isLoading: boolean;

    constructor(private passwordResetInitService: PasswordResetInitService,
                private elementRef: ElementRef,
                private renderer: Renderer2,
                private mixpanel: MixpanelService) {
        this.isLoading = false;
    }

    ngOnInit() {
        this.resetAccount = {};
    }

    ngAfterViewInit() {
        // this.renderer.invokeElementMethod(this.elementRef.nativeElement.querySelector('#email'), 'focus', []);
    }

    requestReset() {
        if (this.resetAccount.email) {
            this.error = null;
            this.mixpanel.track(MixpanelEvent.PASSWORD_FORGOT, {
                username: this.resetAccount.email
            });
            this.isLoading = true;
            this.passwordResetInitService.save(this.resetAccount).pipe(first()).subscribe(() => {
                this.success = 'OK';
                this.isLoading = false;
            }, (err) => {
                this.success = null;
                this.isLoading = false;
                if (err && err.body.message) {
                    this.error = err.body.message;
                } else {
                    this.error = 'Cannot reset password. Please try later or contact Teamlogs'
                }
            });
        }
    }
}
